import menu1 from '../assets/menu/menu1.jpg';
import menu2 from '../assets/menu/menu2.jpg';
import menu3 from '../assets/menu/menu3.jpg';
import menu4 from '../assets/menu/menu4.jpg';
import menu5 from '../assets/menu/menu5.jpg';
import menu6 from '../assets/menu/menu6.jpg';
import menu7 from '../assets/menu/menu7.jpg';
import menu8 from '../assets/menu/menu8.jpg';
import menu9 from '../assets/menu/menu9.jpg';
import menu10 from '../assets/menu/menu10.jpg';
import menu11 from '../assets/menu/menu11.jpg';
import menu12 from '../assets/menu/menu12.jpg';
import menu13 from '../assets/menu/menu13.jpg';
import menu14 from '../assets/menu/menu14.jpg';
import menu15 from '../assets/menu/menu15.jpg';
import menu16 from '../assets/menu/menu16.jpg';
import menu17 from '../assets/menu/menu17.jpg';
import menu18 from '../assets/menu/menu18.jpg';
import menu19 from '../assets/menu/menu19.jpg';
import menu20 from '../assets/menu/menu20.jpg';
import menu21 from '../assets/menu/menu21.jpg';
import menu22 from '../assets/menu/menu22.jpg';
import menu23 from '../assets/menu/menu23.jpg';
import menu24 from '../assets/menu/menu24.jpg';

export const MenuImages = [
  { id: 1, name: 'Morning Glory Breakfast', url: menu1 },
  { id: 2, name: 'Healthy Bites', url: menu2 },
  { id: 3, name: 'Soups', url: menu3 },
  { id: 4, name: 'Starter for Veg', url: menu4 },
  { id: 5, name: '', url: menu5 },
  { id: 6, name: 'Starter for Non-Veg', url: menu6 },
  { id: 7, name: 'Grilled and Baked', url: menu7 },
  { id: 8, name: 'Momo and Burgers', url: menu8 },
  { id: 9, name: 'House of Pasta', url: menu9 },
  { id: 10, name: 'Main Course Vegan & Non-Vegan', url: menu10 },
  { id: 11, name: 'Main Course Veg or Non-Veg', url: menu11 },
  { id: 12, name: 'Aire Special Combo & Sizzler', url: menu12 },
  { id: 13, name: 'Desserts', url: menu13 },
  { id: 14, name: 'Hookah', url: menu14 },
  { id: 15, name: 'Refreshing Beverage', url: menu15 },
  { id: 16, name: 'Beverages', url: menu16 },
  { id: 17, name: 'Cocktails', url: menu17 },
  { id: 18, name: 'Mocktails', url: menu18 },
  { id: 19, name: 'Hot Beverages', url: menu19 },
  { id: 20, name: 'Cold Beverages', url: menu20 },
  { id: 21, name: 'Fresh Juices', url: menu21 },
  { id: 22, name: 'Smoothies & Shakes', url: menu22 },
  { id: 23, name: 'Hookah', url: menu23 },
  { id: 24, name: 'Refreshing Beverage', url: menu24 },
];
